import { CheckoutBasketSummary } from "./CheckoutBasketSummary";

export default CheckoutBasketSummary;
